import React, { type ReactNode } from 'react';
import Flag from '@atlaskit/flag';
import InfoIcon from '@atlaskit/icon/glyph/check-circle';
import { B300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

type RefreshBannerProps = Readonly<{
	reloadEP: () => void;
	title: ReactNode;
	actionLabel: ReactNode;
}>;

const RefreshBanner = ({ reloadEP, title, actionLabel }: RefreshBannerProps) => (
	<Flag
		icon={<InfoIcon primaryColor={token('color.icon.information', B300)} label="Info" />}
		id="refreshBanner"
		title={title}
		actions={[{ content: actionLabel, onClick: reloadEP }]}
	/>
);

export default RefreshBanner;
